import { useCallback } from 'react';

type NavigateInNewPageParams = {
    path: string;
    searchParams?: Record<string, string | undefined>;
};

export const useNavigateInNewPage = () => {
    const navigateInNewPage = useCallback(({ path, searchParams }: NavigateInNewPageParams) => {
        const filteredParams = searchParams
            ? (Object.fromEntries(
                  Object.entries(searchParams).filter(([, v]) => v !== undefined),
              ) as Record<string, string>)
            : {};

        const queryString =
            Object.keys(filteredParams).length > 0
                ? '?' + new URLSearchParams(filteredParams).toString()
                : '';

        const a = document.createElement('a');

        a.href = `${path}${queryString}`;
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        a.click();
    }, []);

    return navigateInNewPage;
};
